import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbModalConfig, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MuiModalFooter } from './modal-footer/mui-modal-footer.component';
import { MuiModalHeader } from './modal-header/mui-modal-header.component';
import { MuiModalBody } from './modal-body/mui-modal-body.component';
import { MuiBasicModal } from './mui-basic-modal.component';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { MuiUtilityModule } from '../utility';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function configureModals(ngbModalConf: NgbModalConfig): () => void {
  /* This MUST be saved in a local variable first, otherwise ng build will throw! */
  const res = (): void => {
    ngbModalConf.windowClass = 'mui-modal';
    ngbModalConf.backdropClass = 'mui-overlay';
    ngbModalConf.backdrop = true;
    ngbModalConf.centered = true;
    ngbModalConf.keyboard = false;
  };
  return res;
}

@NgModule({
  imports: [
    CommonModule,
    NgbModalModule,
    MuiButtonModule,
    MuiIconModule,
    MuiUtilityModule
  ],
  declarations: [
    MuiBasicModal,
    MuiModalHeader,
    MuiModalBody,
    MuiModalFooter
  ],
  exports: [
    NgbModalModule,
    MuiModalHeader,
    MuiModalFooter,
    MuiModalBody,
    MuiBasicModal
  ]
})
export class MuiModalModule {

  /**
   * @deprecated: Use MuiModule.forRoot() instead.
   */
  static forRoot(): ModuleWithProviders<MuiModalModule> {
    return {
      ngModule: MuiModalModule,
      providers: []
    };
  }
}
